import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {filter} from 'rxjs/operators';

let headers: HttpHeaders = new HttpHeaders();

@Injectable()
export class MsgraphServiceService {
  private readonly BASE_URL: string;

  constructor(private http: HttpClient) {
    this.BASE_URL = inject(APP_CONFIG).baseUrl + '/api/pga-drivermgmt/msgraph';

  }

  queryByGMIN($event): Observable<HttpResponse<any>> {
    return this.http.get(this.BASE_URL + '/gmin/' + $event , {
      headers: headers,
      responseType: 'json',
      observe: 'response'
    }).pipe(
      filter(response => response.body && Object.keys(response.body).length > 0)
    );
  }

  queryByName($event): Observable<HttpResponse<any>> {
    return this.http.get(this.BASE_URL + '/name/' + $event , {
      headers: headers,
      responseType: 'json',
      observe: 'response'
    });
  }
}
